/**
 * Created by KryQ on 2017-04-25.
 */

import React, { Component } from 'react';
var axios = require('axios');

class TrapListItem extends Component {
    constructor (props) {
        super(props);

        this.state = {edit: false};
        this.onDbClick = this.onDbClick.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    onDbClick() {
        this.setState({edit: !this.state.edit});
    }

    onSubmit(event) {
        event.preventDefault();

        let refresh = this.props.refresh;

        axios.put(this.props.restIp+'/traps/title', {
            id: this.props.id,
            title: event.target.value
        })
            .then(function (response) {
                console.log(response);
                refresh();
            })
            .catch(function (error) {
                console.log(error);
            });

        this.setState({edit:false});
    }
//{props.online!=null ? <i className="fa fa-link float-right" aria-hidden="true" style={{color: '#409a2f'}}></i> : <i className="fa fa-chain-broken float-right" aria-hidden="true" style={{color: '#9a302b'}}></i>}
    display(props) {
        if (props.title) {
            return (
                <span className="clearfix">
                    <span className="float-left">
                        {props.title} <br />
                        <small>{props.id}</small>
                    </span>
                    <i className="fa fa-link float-right" aria-hidden="true" style={{color: '#409a2f'}}></i>
                </span>
            )
        }
        return (
            <span className="clearfix">
                    <span className="float-left">
                        {props.id} <br />
                    </span>
                {props.online!=null ? <i className="fa fa-link float-right" aria-hidden="true" style={{color: '#409a2f'}}></i> : <i className="fa fa-chain-broken float-right" aria-hidden="true" style={{color: '#9a302b'}}></i>}
                </span>
        )
    }

    render() {
        return (
            // <li className="list" onClick={() => this.props.selectTrap(this.props.id)} onDoubleClick={this.onDbClick}>
            <li className="list" onClick={() => this.props.selectTrap(this.props.id)}>
                {this.state.edit ? <span><input type="text" onBlur={this.onSubmit} defaultValue={this.props.title} /><small>{this.props.id}</small></span> : this.display(this.props)}
            </li>
        );
    }
}

export default TrapListItem;




// WEBPACK FOOTER //
// ./src/components/TrapListItem.js